import { keyBy } from 'lodash'
import {
  GET_SERVICE_TYPE_REQUERSTED,
  GET_SERVICE_TYPE_SUCCEEDED,
  GET_SERVICE_TYPE_FAILED,
  ADD_SERVICE_TYPE_REQUERSTED,
  ADD_SERVICE_TYPE_SUCCEEDED,
  ADD_SERVICE_TYPE_FAILED,
  UPDATE_SERVICE_TYPE_REQUERSTED,
  UPDATE_SERVICE_TYPE_SUCCEEDED,
  UPDATE_SERVICE_TYPE_FAILED,
  CLEAR_SERVICE_TYPES_SUCCEEDED,
} from './constants'

const defaultState = {}
// Remeber service types are menus
const state = (state = defaultState, { type, payload }) => {
  switch (type) {
    //GET
    case GET_SERVICE_TYPE_REQUERSTED:
      return { ...state, isLoading: true }

    case GET_SERVICE_TYPE_SUCCEEDED:
      // store for menus, assigned to current revenue center
      const serviceTypes = keyBy(payload, 'uuid')
      return {
        ...state,
        byId: { ...state.byId, ...serviceTypes },
        isLoading: false,
      }

    case GET_SERVICE_TYPE_FAILED:
      return { ...state, err: payload }

    // ADD
    case ADD_SERVICE_TYPE_REQUERSTED:
      return { ...state, isLoading: true }

    case ADD_SERVICE_TYPE_SUCCEEDED:
      const newServiceType = payload
      return {
        ...state,
        byId: {
          ...state.byId,
          [newServiceType.uuid]: newServiceType,
        },
      }

    case ADD_SERVICE_TYPE_FAILED:
      return { ...state, err: payload }

    //UPDATE
    case UPDATE_SERVICE_TYPE_REQUERSTED:
      return { ...state, isLoading: true }

    case UPDATE_SERVICE_TYPE_SUCCEEDED:
      return {
        ...state,
        byId: {
          ...state.byId,
          [payload.uuid]: payload,
        },
      }

    case UPDATE_SERVICE_TYPE_FAILED:
      return { ...state, err: payload }

    //CLEAR
    case CLEAR_SERVICE_TYPES_SUCCEEDED:
      return { ...state, byId: {} }
    default:
      return state
  }
}

export default state
